export interface MarginContractSlice {
    contractId: number | null;
    contractStageCode: string | null;
    contractTypeCode: string | null;
}

export const initialMarginContractSlice: MarginContractSlice = {
    contractId: null,
    contractStageCode: null,
    contractTypeCode: null
};
